import { render, staticRenderFns } from "./MonitoringParameters.vue?vue&type=template&id=51815855&scoped=true"
import script from "./MonitoringParameters.vue?vue&type=script&lang=js"
export * from "./MonitoringParameters.vue?vue&type=script&lang=js"
import style0 from "./MonitoringParameters.vue?vue&type=style&index=0&id=51815855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51815855",
  null
  
)

export default component.exports